<template>
  <div class="app-result">
   
    <div class="certificate-list">
      <div  class="no-data">
        <img src="/static/image/weatherCertificate/apply_result.png" />
        <div>已提交成功，请等待审核</div>
      </div>
     
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import request from '@/utils/request'
import moment from 'moment'
export default Vue.extend({
  components: {
  },
  data() {
    return {
      list: [],
      

    }
  },
  filters: {
    timeFormat(value) {
      const result = moment(value).format('YYYY-MM-DD HH:mm:ss') // 转换时间格式
       return result 
    },
    getStatus(status) {
      let statusLabel = '待审核'
    
      if(status === 0){
        statusLabel = '待审核'
      }else if(status === 1){
        statusLabel = '审核通过'
      }else if(status === 2){
        statusLabel = '审核未通过'
      }
      return statusLabel
    },
  },
  mounted () {
    
  },
  methods: {
    
  },
})

</script>
<style scoped lang="scss">
.app-result {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 20px;
}


.no-data {
  width: 100vw;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #BBBBBB;
  line-height: 20px;
}

.certificate-list {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.list-item {
  width: 90vw;
  height: 108px;
  box-shadow: 0px 0px 10px 0px rgba(0, 134, 234, 0.1);
  border-radius: 10px;
  margin-top: 10px;

  .title {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    margin: 0 14px;
    line-height: 17px;

    .name {
      font-size: 14px;
      color: #333333;
    }

    .status {
      margin-right: 14px;
      float: right;
      font-size: 12px;
    }

    .status-0 {
      color: #0082E9;
    }

    .status-1 {
      color: #21CC64;
      ;
    }

    .status-2 {
      color: #E95600;
      ;
    }
  }

  .conent {
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    color: #333330;
    align-items: center;
    margin: 10px 14px;

    .label {
      padding-top: 3px;
      color: #BBBBBB;
    }
  }

}
</style>
